import { useEffect } from 'react'

import { CampLoader } from '@/components/CampLoader'

/** Outside the dashboard shell: the camp's waiting screen while the browser leaves for the admin site. */
export function AdminPage() {
  useEffect(() => {
    window.location.href = 'https://admin.badland.ai'
  }, [])

  return <CampLoader label="Redirecting to admin.badland.ai..." />
}
